module.exports = __webpack_public_path__ + "img/logo.900847fe.png";